export default "__VITE_ASSET__BnKFR9oZ__"